
import Api from '@/api'
import Constants from '@/util/constants'

export default {
  saveSale (params) {
    const MARKET_URL = Constants.URL.MARKET_URL

    return Api.request({
      url: `${MARKET_URL}${params.outletId}/sale`,
      data: params.data
    })
  },

  getSale (params) {
    const MARKET_URL = Constants.URL.MARKET_URL

    return Api.request({
      url: `${MARKET_URL}${params.outletId}/sale/${params.saleId}`
    })
  },

  verifyAndPostPayment (params) {
    const MARKET_URL = Constants.URL.MARKET_URL

    return Api.request({
      url: `${MARKET_URL}${params.outletId}/sale/${params.saleId}/payment`,
      data: params.data
    })
  },

  fetchCustomerLoyaltyPoints (params) {
    const MARKET_URL = Constants.URL.MARKET_URL

    return Api.request({
      url: `${MARKET_URL}${params.outletId}/customer`,
      method: 'GET',
      params: params.data
    })
  }
}
